export default __webpack_public_path__ + "static/media/icons8-next_page.ffceb19f.svg";